import { useParams } from 'react-router-dom'
import { useCallback, useEffect, useState } from 'react'
import { useAuth } from '@/hooks/useAuth'

import { ViewType } from '../student.admin'
import { AlunoRepository } from '@/pages/admin/repositories/aluno.repository'

import { AddDocument } from './add-document'
import { Document } from './document'
import { Loader } from '@/components/Loader'

export interface IStudentProps {
  view: ViewType
  setView: React.Dispatch<React.SetStateAction<ViewType>>
}

export interface IDocument {
  id: number
  tipo: string
  arquivo: string
}

export const Documents = ({ view, setView }: IStudentProps) => {
  const { id } = useParams()
  const { token } = useAuth()
  const [loading, setLoading] = useState(false)
  const [documents, setDocuments] = useState<IDocument[]>([])

  const listDocuments = useCallback(async () => {
    try {
      setLoading(true)
      const documentos = await AlunoRepository.GetInstance().adminListDocuments(
        token,
        id,
      )
      setDocuments(documentos)
    } catch (error) {
      console.error('error: ', error)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    listDocuments()
  }, [listDocuments])

  return (
    <>
      {loading && <Loader />}
      <div>
        <p>Documentos</p>
        {view == 'ADD DOCUMENT' && (
          <Document
            setDocuments={setDocuments}
            setLoading={setLoading}
            setView={setView}
          />
        )}

        {view == 'DOCUMENTS' && (
          <AddDocument
            documents={documents}
            setView={setView}
            listDocuments={listDocuments}
            setLoading={setLoading}
          />
        )}
      </div>
    </>
  )
}
